import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgxSpinnerService } from "ngx-spinner";
import { ToastrService } from "ngx-toastr";
import { SuperAdminService } from "src/app/super-admin.service";

@Component({
  selector: "app-monthly-lr-expense",
  templateUrl: "./monthly-lr-expense.component.html",
  styleUrls: ["./monthly-lr-expense.component.css"],
})
export class MonthlyLrExpenseComponent implements OnInit {

  monthArr = [
    "Jan", "Feb", "Mar", "Apr", "May", "June",
    "July", "Aug", "Sep", "Oct", "Nov", "Dec",
  ];

  monthArrFull = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];

  paramId: any;
  month: string;
  year: number;

  type: "LR" | "Tracker" = "LR";

  LrExpenseArray: any[] = [];
  userSessionData: any = JSON.parse(sessionStorage.getItem("userSession"));

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private superadminService: SuperAdminService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {

    this.activatedRoute.params.subscribe((param) => {
      this.paramId = param.month;
      this.month = this.monthArrFull[this.monthArr.indexOf(this.paramId)];
      this.year = +param.year;
    });

    this.activatedRoute.queryParams.subscribe((query) => {
      this.type = query.type === "Tracker" ? "Tracker" : "LR";
    });

    this.getLrExpenseGroup();
  }

  getLrExpenseGroup() {
    this.spinner.show();

    this.superadminService.getLRExpenseParticularMonth(this.type).subscribe(
      (res: { status: boolean; message: string; data: any[] }) => {
        if (!res.status) {
          this.handleError(res);
          return;
        }

        const role = this.userSessionData.user_role_id[0];
        let filteredData = res.data;

        filteredData = filteredData.filter(
          (item) => item.year === this.year
        );

        if (role !== 1 && role !== 7) {
          filteredData = filteredData.filter(
            (item) => item.supervisorId === this.userSessionData._id
          );
        }

        filteredData = filteredData.filter(
          (item) => this.monthArr[item.month - 1] === this.paramId
        );

        this.LrExpenseArray = filteredData.map((item) => ({
          supervisorId: item.supervisorId,
          supervisorName: item.supervisorName,
          companyId: item.companyId,
          companyName: item.companyName,
          amount: item.amount,
        }));

        this.spinner.hide();
      },
      () => {
        this.spinner.hide();
        this.toastr.error("Something went wrong");
      }
    );
  }

  handleError(res: any) {
    this.spinner.hide();

    if (res.status === 401) {
      this.toastr.error(res.message);
      sessionStorage.clear();
      this.router.navigateByUrl("superAuth/login");
    } else {
      this.toastr.error(res.message);
    }
  }

  backTo() {
    window.history.back();
  }
}
